import moment from 'moment'

import { getLocalIpPrefix } from './persistence'

console.log('process.env', process.env)

const serverHost = process.env.REACT_APP_NODE_HOST
const isProduction = process.env.REACT_APP_PRODUCTION_MODE || process.env.NODE_ENV === 'production'
const ipPrefix = getLocalIpPrefix() || '192.168.1'

const config = {
	fridge: {
		host: process.env.REACT_APP_FRIDGE_API_HOST,
	},
	server: {
		getHost: async () => {
			// if (serverHost.includes('localhost') && !['development', 'test'].includes(process.env.NODE_ENV)) {
			// 	// TODO: can it be localhost instead?
			// 	// @ts-ignore
			// 	const ipInfo: any = await new Promise((res, rej) => window?.networkinterface?.getWiFiIPAddress(res, rej))
			// 	return `http://${ipInfo.ip}:3000`
			// } else {
			// 	return serverHost
			// }
			return serverHost
		},
		start: serverHost === undefined || serverHost.includes('localhost'),
	},
	version: process.env.REACT_APP_VERSION,
	devMode: process.env.REACT_APP_DEV_MODE + '' === 'true',
	isProduction,
	disableSystemCheck: false,
	buildConstants: {
		ciBuildNumber: process.env.REACT_APP_CI_BUILD_NUMBER,
		builtAt: process.env.REACT_APP_BUILT_AT,
		version: process.env.REACT_APP_VERSION,
		commitHash: process.env.REACT_APP_COMMIT_HASH,
	},
	idleTimeout: moment.duration(5, 'minutes').asMilliseconds(),
	metabaseDashboardUrl: 'https://scale.kitchenmate.com/public/dashboard/0e36261e-c2ea-4e7d-b83f-b87fccc3e0ba#bordered=false&titled=false',
	ipPrefix,
	resize: 0.5,
}

console.log('Config', config)

export default config
